import { render, staticRenderFns } from "./EmergencyContact.vue?vue&type=template&id=08db31a5&scoped=true"
import script from "./EmergencyContact.vue?vue&type=script&lang=ts"
export * from "./EmergencyContact.vue?vue&type=script&lang=ts"
import style0 from "./EmergencyContact.vue?vue&type=style&index=0&id=08db31a5&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08db31a5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08db31a5')) {
      api.createRecord('08db31a5', component.options)
    } else {
      api.reload('08db31a5', component.options)
    }
    module.hot.accept("./EmergencyContact.vue?vue&type=template&id=08db31a5&scoped=true", function () {
      api.rerender('08db31a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyProjects/ClientTabsComponents/Steps/ClientProfileSteps/EmergencyContact.vue"
export default component.exports